"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var cache_1 = require("../../../common/graphql/cache");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var EnquiryForm_1 = require("../../../commonSteps/enquiryForm/components/enquiryForm/EnquiryForm");
var useJourneyStepsContext_1 = require("../../hooks/useJourneyStepsContext");
var UrlParamTypes_1 = require("../../../../common/enum/UrlParamTypes");
var useUrlDealId_1 = require("../../../common/hooks/useUrlDealId");
var react_router_1 = require("react-router");
var JourneyStepsRoutes_1 = require("../../enum/JourneyStepsRoutes");
var CustomerInformation = function (_a) {
    var stateId = _a.stateId;
    var handleNext = useJourneyStepsContext_1.default().handleNext;
    var currentJourney = cache_1.activeJourneyType();
    var history = react_router_1.useHistory();
    var token = useUrlDealId_1.default();
    var goToNextStep = react_1.useCallback(function () {
        switch (currentJourney) {
            case globalTypes_1.JourneyType.continue_in_dealership:
                history.replace({
                    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.CONFIRMATION,
                    search: "?" + UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token,
                });
                break;
            default:
                handleNext();
        }
    }, [currentJourney]);
    return <EnquiryForm_1.default stateId={stateId} journeyType={cache_1.activeJourneyType()} goToNextStep={goToNextStep}/>;
};
exports.default = CustomerInformation;
